import { render, staticRenderFns } from "./FixedBottomRight.vue?vue&type=template&id=0af339ec&scoped=true&lang=pug&"
var script = {}
import style0 from "./FixedBottomRight.vue?vue&type=style&index=0&id=0af339ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af339ec",
  null
  
)

component.options.__file = "FixedBottomRight.vue"
export default component.exports